import "../CSS/werdegang.css";

import Seo from "../components/Seo";


function WerdegangPage() {

    const stationen = [

        {
            zeitraum: "2024–Heute",
            funktion: "Stv Leiter IT/Technik",
            firma: "Casino Bad Ragaz AG",
            text:
                "Unterhalt und Wartung der Spielautomaten und elektronischen Geräte. " +
                "Wartung und Unterhalt der Netzwerkinfrastruktur. " +
                "Seit September 2025 Train the Trainer. " +
                "Seit Oktober 2025 zusätzlich QMS und Datenschutzverantwortlicher."
        },

        {
            zeitraum: "2022–2024",
            funktion: "Bereichsleiter Standardleuchten",
            firma: "smarterion ag",
            text:
                "Leiten der Abteilung Standard- und Sonderleuchten. " +
                "Führen von bis zu 12 Leuten bei der Produktion von LED Leuchten."
        },

        {
            zeitraum: "2019–2022",
            funktion:
                "Leiter Fabrikation und Renovationen und Verantwortlicher IT",
            firma: "ETA Technik AG (uniwash)",
            text:
                "Führen und leiten der Fabrikation. Herstellung diverser Bauteile " +
                "für den sicheren Betrieb der Autowaschanlagen. Mithilfe in der " +
                "Entwicklung von neuen Steuerungen und Konstruktionen. " +
                "First Level Support für die ganze IT-Infrastruktur."
        },

        {
            zeitraum: "2016–2019",
            funktion: "Produktionsleiter",
            firma: "HWJ AG",
            text:
                "Zusätzliche Übernahme des Jobs als Produktionsleiter. " +
                "Planen der Arbeitsabläufe für die Mechanik, Montage und Elektroarbeiten. " +
                "Führen des Montageteams beim Aufbau der Maschinen und bei der " +
                "Inbetriebnahme beim Kunden."
        },

        {
            zeitraum: "2004–2016",
            funktion: "Leiter Elektrotechnik",
            firma: "HWJ AG",
            text:
                "Planung der Steuerungen (Schaltplanzeichnen Eplan P8), " +
                "Verdrahten und Testen der Steuerungen, Einsatzplanung der Elektroabteilung, " +
                "Ausbildung der Automatiker Lehrlinge im Fachbereich."
        },

        {
            zeitraum: "2003–2004",
            funktion: "AVOR",
            firma: "HWJ AG",
            text:
                "Bereitstellen von Materialien und Papieren für die mechanische Bearbeitung, " +
                "Mithilfe bei Montagearbeiten und Inbetriebnahmen von Maschinen und Anlagen."
        },

        {
            zeitraum: "2001–2003",
            funktion: "Zeitmilitär",
            firma: "Festungs-Rekrutenschule Mels",
            text:
                "Ausbildung der angehenden Unteroffiziere im Fachbereich Personenkontrolle, " +
                "Gepäckkontrolle und Zutrittskontrolle. Leiten diverser Rekrutenschulen " +
                "als Kompanie Kommandant oder Kompanie Kommandant Stellvertreter."
        },

        {
            zeitraum: "1998–2001",
            funktion: "Elektromechaniker",
            firma: "HWJ AG",
            text:
                "Mechanische und elektrische Fertigung von Schaltschränken. " +
                "Verdrahten und Testen der Anlagen. Mithilfe beim mechanischen Aufbau " +
                "der Montagelinien und Automationsanlagen."
        }

    ];


    return (

        <>

            <Seo
                title="Werdegang"
                description="Beruflicher Werdegang von Ivan Jörg mit Stationen in IT, Technik, Produktion, Elektrotechnik, Automation und Führung."
                canonical="https://www.irj.ch/werdegang"
            />


            <div className="intro">

                <p>
                    Hier kannst Du meinen persönlichen Werdegang sehen.
                </p>

            </div>


            <main>

                <div className="karten-container">

                    {
                        stationen.map(
                            (eintrag, index) => (

                                <article
                                    className="content-card"
                                    key={index}
                                >

                                    <span className="card-jahr">
                                        {eintrag.zeitraum}
                                    </span>


                                    <h2>
                                        {eintrag.funktion}
                                    </h2>


                                    <p className="card-zusatz">
                                        {eintrag.firma}
                                    </p>


                                    <p className="card-text">
                                        {eintrag.text}
                                    </p>

                                </article>

                            )
                        )
                    }

                </div>

            </main>

        </>

    );
}


export default WerdegangPage;